import { GeneralModel } from "./general.model";

export class Report extends GeneralModel {}
